import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL, assetUrl } from "../config/api";
import { Link } from "react-router-dom";
import Header from "../include/Header";
import CustomBreadcrumb from "../include/Breadcrumb";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Image,
  Pagination,
  Modal,
} from "react-bootstrap";

function Updateproduct() {

  // ===============================
  // 🧠 STATE (DATA STORAGE)
  // ===============================

  const [products, setProducts] = useState([]); // all products list
  const [search, setSearch] = useState(""); // search text

  const [show, setShow] = useState(false); // modal open/close

  const [editId, setEditId] = useState(""); // (optional use)

  const [editData, setEditData] = useState({
    name: "",          // product name
    description: "",   // product description
    price: "",         // product price
    image: null,       // new image upload
    oldImage: "",      // old image show
  });

  // ===============================
  // 📥 GET ALL PRODUCTS FROM API
  // ===============================

  const getProducts = async () => {
    try {
      const res = await axios.get(`${API_URL}/products`);
      setProducts(res.data.products); // store in state
    } catch (error) {
      console.log(error);
    }
  };

  // page load pe API call
  useEffect(() => {
    getProducts();
  }, []);

  // ===============================
  // 🗑️ DELETE PRODUCT
  // ===============================

  const deleteProduct = async (id) => {

    // confirmation popup
    if (!window.confirm("Delete this product?")) return;

    try {
      await axios.delete(
        `${API_URL}/delete-product/${id}`
      );

      alert("Product Deleted Successfully");

      getProducts(); // refresh list
    } catch (error) {
      console.log(error);
    }
  };

  // ===============================
  // 🔍 SEARCH FILTER
  // ===============================

  const filterProducts = products.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  // ===============================
  // ✏️ OPEN EDIT MODAL
  // ===============================

  const openEditModal = (product) => {
    setShow(true); // open popup

    // selected product data fill in form
    setEditData({
      id: product.id,
      name: product.name,
      description: product.description,
      price: product.price,
      image: null,
      oldImage: product.file_path,
    });
  };

  // close modal
  const closeEditModal = () => {
    setShow(false);
  };

  // ===============================
  // 💾 UPDATE PRODUCT API
  // ===============================

  const updateProduct = async () => {

    const data = new FormData(); // image upload ke liye

    data.append("name", editData.name);
    data.append("description", editData.description);
    data.append("price", editData.price);

    // agar new image hai to send karo
    if (editData.image) {
      data.append("image", editData.image);
    }

    try {
      const res = await axios.post(
        `${API_URL}/update-product/${editData.id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert(res.data.message);

      closeEditModal(); // modal close

      getProducts(); // refresh list
    } catch (error) {
      console.log(error.response?.data);
      alert("Update Failed");
    }
  };

  // ===============================
  // 🖥️ UI START
  // ===============================

  return (
    <>
      <Header />

      <div className="ved">

        {/* ===============================
            ✏️ EDIT MODAL POPUP
        =============================== */}
        <Modal show={show} onHide={closeEditModal} centered>

          <Modal.Header closeButton>
            <Modal.Title>Edit Product</Modal.Title>
          </Modal.Header>

          <Modal.Body>

            {/* IMAGE PREVIEW */}
            <div className="text-center mb-3">
              <Image
                src={
                  editData.image
                    ? URL.createObjectURL(editData.image)
                    : assetUrl(editData.oldImage)
                }
                width="120"
                height="120"
                rounded
              />
            </div>

            {/* IMAGE INPUT */}
            <Form.Group className="mb-3">
              <Form.Label>Product Image</Form.Label>

              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    image: e.target.files[0],
                  })
                }
              />
            </Form.Group>

            {/* NAME */}
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>

              <Form.Control
                type="text"
                value={editData.name}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    name: e.target.value,
                  })
                }
              />
            </Form.Group>

            {/* DESCRIPTION */}
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>

              <Form.Control
                as="textarea"
                rows={3}
                value={editData.description}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    description: e.target.value,
                  })
                }
              />
            </Form.Group>

            {/* PRICE */}
            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>

              <Form.Control
                type="number"
                value={editData.price}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    price: e.target.value,
                  })
                }
              />
            </Form.Group>

          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={closeEditModal}>
              Close
            </Button>

            <Button variant="success" onClick={updateProduct}>
              Save Changes
            </Button>
          </Modal.Footer>

        </Modal>

        {/* ===============================
            📦 MAIN CONTENT
        =============================== */}

        <Container className="mt-5">

          <CustomBreadcrumb title="Product Listing" />

          {/* HEADER + SEARCH */}
          <Row className="mb-4 align-items-center">

            <Col md={6}>
              <h2>Product List</h2>
            </Col>

            <Col md={6}>
              <div className="d-flex">

                <Form.Control
                  type="text"
                  placeholder="Search Product..."
                  className="me-2"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />

                <Button variant="primary">
                  Search
                </Button>

              </div>
            </Col>

          </Row>

          {/* ===============================
              📋 TABLE
          =============================== */}

          <Table striped bordered hover responsive>

            <thead>
              <tr>
                <th>ID</th>
                <th>Image</th>
                <th>Product Name</th>
                <th>Description</th>
                <th>Price</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {/* if products exist */}
              {filterProducts.length > 0 ? (
                filterProducts.map((item) => (
                  <tr key={item.id}>

                    <td>{item.id}</td>

                    <td>
                      <Image
                        src={assetUrl(item.file_path)}
                        width="60"
                        height="60"
                        rounded
                      />
                    </td>

                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>₹ {item.price}</td>

                    <td>

                      {/* EDIT BUTTON */}
                      <Button
                        variant="warning"
                        size="sm"
                        className="me-2"
                        onClick={() => openEditModal(item)}
                      >
                        Edit
                      </Button>

                      {/* DELETE BUTTON */}
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => deleteProduct(item.id)}
                      >
                        Delete
                      </Button>

                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Product Found
                  </td>
                </tr>
              )}

            </tbody>

          </Table>

          {/* ===============================
              📄 PAGINATION (STATIC)
          =============================== */}

          <div className="d-flex justify-content-center mt-4">

            <Pagination>
              <Pagination.Prev />
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Next />
            </Pagination>

          </div>

        </Container>

      </div>
    </>
  );
}

export default Updateproduct;